var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tipBanner"},[_c('div',{staticClass:"main-width tipBanner__content"},[_c('div',{staticClass:"tipBanner__btn",on:{"click":_vm.handleCooperate}},[_vm._v("我要合作")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }